module.exports = __webpack_public_path__ + "img/icon-current_status_online.2b8173f8.svg";